import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Markers from './components/Markers';
import RadarSonar from './components/RadarSonar';
import RecenterPin from './components/RecenterPin';
import MapErrorBoundary from '../../../../../../../shared/components/MapErrorBoundary';

import { Map } from 'hosman-material';
import { updateMap } from '../../../../../../reducers/_Pages/Public/radarSlice';

const Radar = () => {
  const { map, coordinates, zoom } = useSelector((state) => state.radar);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!map) return;

    map.current.flyTo({
      center: { lat: coordinates[1], lng: coordinates[0] },
      zoom: zoom,
      duration: 1000
    });
  }, [map, coordinates, zoom]);

  return (
    <>
      {process.env.NODE_ENV !== 'test' &&
        <MapErrorBoundary>
          <div className='relative overflow-hidden pointer-events-auto'>
            <Map
              accessToken={process.env.MAPBOX_PUBLIC_KEY}
              style='mapbox://styles/mapbox/dark-v11'
              center={{ lat: coordinates[1], lng: coordinates[0] }}
              zoom={zoom}
              sendMapToParent={(e) => dispatch(updateMap(e))}
              borderClasses='border-none'
              width= 'w-screen'
              height= 'h-[100dvh]'
            />

            <Markers />

            <RadarSonar />

            <RecenterPin />
          </div>
        </MapErrorBoundary>
      }
    </>
  )
}

export default Radar;
